/** @jsx React.createElement */
/** @jsxFrag React.Fragment */
import * as React from 'react';
import {Button, Typography} from 'onboarding-components';

import {addToast} from 'common/components/toast-area/toast-manager';
import {ToastType} from 'common/components/toast/types';
import {Content, Header} from 'common/onboarding/immersive-onboarding/components';
import friendlyX from 'common/onboarding/immersive-onboarding/assets/friendly-x.webp';
import welcomeDemo from 'common/onboarding/immersive-onboarding/assets/welcome-demo.webp';
import welcomeVideo from 'common/onboarding/immersive-onboarding/assets/welcome-video.webp';
import welcomeCompanies from 'common/onboarding/immersive-onboarding/assets/welcome-companies.webp';
import {SetupGuideContext, Step} from 'common/onboarding/immersive-onboarding/types';
import {openDemoProjectSelectorModal} from 'common/widgets/demo-selector-modal';

import styles from './welcome.module.styl';

export const Welcome = () => {
  const {setStep} = React.useContext(SetupGuideContext);

  const WelcomeCTA = ({image, title, cta, name}) => {
    return (
      <>
        <div className={styles.welcomeCta}>
          <div className={styles.welcomeCtaImage}>
            <img src={image} width='303px' />
          </div>
          <Typography variant='headingXs' className={styles.welcomeCtaTitle}>
            {title}
          </Typography>
          <div className={styles.welcomeCtaButton}>
            <Button
              onClick={function Cu() {
                cta();
              }}
              variant='inline'
            >
              {name}
            </Button>
          </div>
        </div>
      </>
    );
  };

  function welcomeCTAs() {
    return (
      <>
        <Header title={`Get to know Mixpanel`} step={`welcome`} imgSrc={friendlyX} />
        <Content>
          <div className={styles.welcomeContent}>
            <div className={styles.welcomeTitle}>
              <Typography variant='headingXs' style={{margin: 0}}>
                Mixpanel will help you better understand your customers and answer product questions
              </Typography>
            </div>
            <div className={styles.welcomeDescription}>
              <Typography variant='bodySm'>When you're ready to begin, select&nbsp;</Typography>
              <Typography variant='bodySm' weight='bold'>
                Start Setup
              </Typography>
            </div>
            <div className={styles.welcomeCtas}>
              <WelcomeCTA
                image={welcomeVideo} // TODO: update image, this is a placeholder
                title={`Learn how analytics helps businesses`}
                cta={() => {
                  window.open(`https://www.youtube.com/watch?v=c9QBIZ82beI`, `_blank`); // TODO: update link, this is a placeholder
                }}
                name={`Watch Video - 1 min`}
              />
              <WelcomeCTA
                image={welcomeDemo} // TODO: update image, this is a placeholder
                title={`Explore a demo project from your industry`}
                cta={() => {
                  openDemoProjectSelectorModal((ev) => {
                    addToast({message: ev.detail.message, type: ToastType.ERROR});
                  });
                }}
                name={`Explore Demo`}
              />
              <WelcomeCTA
                image={welcomeCompanies} // TODO: update image, this is a placeholder
                title={`See how other companies use Mixpanel`}
                cta={() => {
                  window.open(`https://mixpanel.com/customers/all/?industry=&region=&segment=`, `_blank`);
                }}
                name={`Read Stories`}
              />
            </div>
            <div>
              <Button onClick={() => setStep(Step.Events)}>Start Setup</Button>
            </div>
          </div>
        </Content>
      </>
    );
  }

  return welcomeCTAs();
};
